import { Http, Response, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { AuthHttp } from 'angular2-jwt';
import { identifierModuleUrl } from '@angular/compiler';


@Injectable()
export class MemberService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  getMembers() {
    return this.authHttp.get('/api/members').map(res => res.json());
  }

  getSimpleMembers() {
    return this.authHttp.get('/api/members/simple').map(res => res.json());
  }

  getAllHiddenMembers(){
    return this.authHttp.get('/api/members/hidden').map(res => {
      return { 'status': res.status, 'value': res.json() }
    });
  }

  unhideMember(id: number){
    return this.authHttp.put('/api/members/unhide/'+id,null).map(res => {
      return { 'status': res.status, 'value': "" }
    });
  }

  create(member: any) {
    return this.authHttp.post('/api/members', member).map( (res:any) => {
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return { 'status': res.status, 'value': value };
    });
  }

  update(member: any) {
    // console.log("member voor update: "+member);
    return this.authHttp.put('/api/members/' + member.id, member).map(res => res.json());
  }

  getMember(id: number) {
    return this.authHttp.get('/api/members/' + id).map(res => res.json());
  }

  getMemberByAuthId(id: string) {
    return this.authHttp.get('/api/members/auth/' + id).map(res => res.json());
  }

  delete(id: number) {
    return this.authHttp.delete("/api/members/" + id).map(res => res.json());
  }

  deleteReal(id: number) {
    return this.authHttp.delete("/api/members/real/" + id).map( (res:any) => {
      let value = "";
      if (res.status == 200){
        value=res.json();
      }
      return { 'status': res.status, 'value': value };
    });
  }

  resetSubscriptions() {
    return this.authHttp.get('/api/members/resetAllhasPayedMemberShip').map(res => res.status);
  }

  downloadExcel() {
    return this.authHttp.get('/api/members/generateXlsx', { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }

  uploadFile(memberId: number, file: any) {
    var formData = new FormData();
    formData.append("file", file);
    // console.log(memberId)
    // console.log("FormData");
    // console.log(formData);
    return this.authHttp
      .post(`/api/members/uploadProfilePicture/${memberId}`, formData)
      .map(res => res.json());
  }

  newMemberRequest(member:any){
    return this.authHttp.post('/api/members/new', member).map(res => res.status);
  }

  getAllNewMemberRequests(){
    return this.authHttp.get('/api/members/newMemberRequests').map( res => res.json())
  }

  deleteNewMemberRequest(id: number){
    return this.authHttp.delete('/api/members/deleteNewMemberRequests/'+id).map(res => res.json())
  }

  downloadMembercard(id:number) {
    return this.authHttp.get('/api/members/getMemberCard/'+id, { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }

  downloadHealthInsurancePaper(id:number){
    return this.authHttp.get('/api/members/getHealthInsurancePaper/'+id, { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }


  downloadMembersForGmailContacts(){
    return this.authHttp.get('/api/members/ExportEmailsForGmail', { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }

  checkMemberCard(tocheck:string){
    return this.authHttp.get("/api/members/checkMemberCard/"+tocheck).map( (res:any)=>{
      let value = "";
      if (res.status == 200){
        value=res.json();
      }
      return { 'status': res.status, 'value': value }
    })
  }

  changeMemberShipPayment(memberId:number, set:boolean){
    return this.authHttp.put("/api/members/changeMemberShipPayment/"+memberId+"/"+set, null).map( (res:any)=>{
      let value = "";
      if (res.status == 200){
        value=res.json();
      }
      return { 'status': res.status, 'value': value }
    })
  }

  hasMemberPayed(id: number){
    return this.authHttp.get("/api/members/hasPayed/"+id).map( (res:any)=>{
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status': res.status, 'value':value}
    })
  }

  getDiscountUsedForMember(id: number){
    return this.authHttp.get('/api/members/discountsUsed/'+id).map( (res:any)=>{
      return { 'status': res.status, 'value': res.json() }
    })
  }

  setDiscountsUsedForMember(memberid: number, discounts:any){
    return this.authHttp.post('/api/members/setDiscountsUsedForMember/'+memberid,discounts).map( (res:any)=>{
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    })
  }

  getNumberOfEmailAddresses( onlyPayedMembers?:boolean){
    if (typeof onlyPayedMembers === 'undefined') {
      onlyPayedMembers = false;
    }

    return this.authHttp.get('/api/members/getNumberOfEmailAddresses/'+onlyPayedMembers).map( (res:any)=>{
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    } )
  }

  sendAllHealthInsurancePapers(){
    return this.authHttp.get('/api/members/sendHealthInsurancePaper/all').map( (res:any)=>{
      let value= "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    }) 
  }

  getAmountMemberSubscriptionEmails(){
    return this.authHttp.get('/api/members/getAmountMemberSubscriptionEmails/').map( (res:any)=>{
      let value = 0;
      if (res.status == 200){
        value = +res.json()
      }
      return {'status':res.status, 'value': value}
    } )
  }

  sendAllMemberSubscriptionPaymentEmails(){
    return this.authHttp.get('/api/members/sendMemberSubscriptionEmails/all').map( (res:any)=>{
      let value:any = {};
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    } )
  }

  sendMemberSubscriptionPaymentEmail(memberid:number){
    return this.authHttp.get('/api/members/sendMemberSubscriptionEmails/'+memberid).map(res => {
      return { 'status': res.status, 'value': res.json() }
    });
  }

  subscriptionAmountForId(id:number){
    return this.authHttp.get('/api/members/subscriptionAmount/'+id).map( (res:any)=>{
      let value:any = {};
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    } )
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/member.service.ts